function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import UserMenuNotificationsList from "discourse/components/user-menu/notifications-list";
import { ajax } from "discourse/lib/ajax";
import UserMenuBookmarkItem from "discourse/lib/user-menu/bookmark-item";
import UserMenuNotificationItem from "discourse/lib/user-menu/notification-item";
import Bookmark from "discourse/models/bookmark";
import Notification from "discourse/models/notification";
import I18n from "discourse-i18n";
var _UserMenuBookmarksList_brand = /*#__PURE__*/new WeakSet();
export default class UserMenuBookmarksList extends UserMenuNotificationsList {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _UserMenuBookmarksList_brand);
  }
  get dismissTypes() {
    return ["bookmark_reminder"];
  }
  get showAllHref() {
    return `${this.currentUser.path}/activity/bookmarks`;
  }
  get showAllTitle() {
    return I18n.t("user_menu.view_all_bookmarks");
  }
  get showDismiss() {
    return _classPrivateGetter(_UserMenuBookmarksList_brand, this, _get_unreadBookmarkRemindersCount) > 0;
  }
  get dismissTitle() {
    return I18n.t("user.dismiss_bookmarks_tooltip");
  }
  get itemsCacheKey() {
    return "user-menu-bookmarks-tab";
  }
  get emptyStateComponent() {
    return "user-menu/bookmarks-list-empty-state";
  }
  get dismissConfirmationText() {
    return I18n.t("notifications.dismiss_confirmation.body.bookmarks", {
      count: _classPrivateGetter(_UserMenuBookmarksList_brand, this, _get_unreadBookmarkRemindersCount)
    });
  }
  async fetchItems() {
    const data = await ajax(`/u/${this.currentUser.username}/user-menu-bookmarks`);
    const content = [];
    const notifications = data.notifications.map(n => Notification.create(n));
    await Notification.applyTransformations(notifications);
    notifications.forEach(notification => {
      content.push(new UserMenuNotificationItem({
        notification,
        currentUser: this.currentUser,
        siteSettings: this.siteSettings,
        site: this.site
      }));
    });
    const bookmarks = data.bookmarks.map(b => Bookmark.create(b));
    await Bookmark.applyTransformations(bookmarks);
    content.push(...bookmarks.map(bookmark => {
      return new UserMenuBookmarkItem({
        bookmark,
        siteSettings: this.siteSettings,
        site: this.site
      });
    }));
    return content;
  }
}
function _get_unreadBookmarkRemindersCount(_this) {
  const key = `grouped_unread_notifications.${_this.site.notification_types.bookmark_reminder}`;
  // we're retrieving the value with get() so that Ember tracks the property
  // and re-renders the UI when it changes.
  // we can stop using `get()` when the User model is refactored into native
  // class with @tracked properties.
  return _this.currentUser.get(key) || 0;
}